import React from "react";
import { Container, Typography, Button, Box, Divider } from "@mui/material";
import "./FAQ.css";
import { useSelector } from "react-redux";
import { t } from "../../utils/i18n";
import ButtonSys from "../../common/ButtonSys";
const FAQ = () => {
  const lang = useSelector((state) => state.i18n.lang);
  const faqsState = useSelector((state) => state.productData.faqs);
  const faqs = Array.isArray(faqsState.data)
    ? faqsState.data.map((f) => ({
        question: lang === "ar" ? f.question_ar : f.question,
        answer: lang === "ar" ? f.answer_ar : f.answer,
      }))
    : [];

  if (faqs.length === 0) return null;

  return (
    <div id="faq">
      <Box
        className="main-section"
        sx={{
          px: "30px !important",
          width: "90%",
          mx: "auto",
          mb: 2,
          bgcolor: (theme) => theme.palette.background.reviews,
        }}
      >
        <Typography
          variant="h6"
          fontWeight={400}
          mb={0}
          className="reviews-title"
        >
          {t(lang, "faq.your_quick_guide")}
        </Typography>
        <Typography variant="h2">{t(lang, "faq.exp_nc")}</Typography>

        <Box
          className="faq-content"
          sx={{
            bgcolor: (theme) => theme.palette.background.faq,
            "&::-webkit-scrollbar": {
              width: "10px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#fff",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#000000ff",
              borderRadius: "10px",
            },
            "&::-webkit-scrollbar-thumb:hover": {
              background: "#555",
            },
          }}
        >
          <Typography
            variant="h4"
            letterSpacing={3}
            fontWeight={500}
            className="faq-subtitle"
            sx={{
              borderBottomWidth: "1px",
              borderBottomStyle: "solid",
              borderBottomColor: (theme) =>
                theme.palette.background.globalButton,
            }}
          >
            {t(lang, "faq.title")}
          </Typography>
          <Typography variant="h6" fontWeight={400} my={2}>
            {t(lang, "faq.description")}
          </Typography>

          <div className="faq-list">
            {faqs.map((faq, index) => (
              <>
                <Divider
                  sx={{
                    width: "100%",
                    borderColor: (theme) => theme.palette.background.reviewCard,
                  }}
                />
                <Box key={index} py={2.5}>
                  <Typography variant="h5" fontWeight={500}>
                    {index + 1}. {faq.question}
                  </Typography>
                  <Typography
                    variant="h5"
                    fontWeight={400}
                    dangerouslySetInnerHTML={{ __html: faq.answer }}
                  />
                </Box>
              </>
            ))}
          </div>
        </Box>
        <ButtonSys
          onClick={() => {
            const el = document.getElementById("contact-us");
            if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          text={t(lang, "nav.get_in_touch")}
        />
      </Box>
    </div>
  );
};

export default FAQ;
